
export default function checkDeviceType() {
  let res = null;
  if ('ontouchstart' in document.documentElement) {
    res = 'touchscreen';
  }
  return res;
}
